import { Directive, ElementRef, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({ 
    selector: '[libRawDateValue]',
    standalone: false 
})
export class RawDateValueDirective {
  constructor(private el: ElementRef<HTMLInputElement>, private ngControl: NgControl) {}

  @HostListener('keyup')
  keyup() {
    if (this.ngControl.control) {
      (this.ngControl.control as any)._rawValue = this.el.nativeElement.value;
      this.ngControl.control.updateValueAndValidity();
    }
  }
}